import React from "react";
import { RefreshCw } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Return & Exchange policy notice — reused on product pages, checkout modal,
 * and anywhere else the customer is making a purchasing decision.
 *
 * Compact variant (`variant="compact"`) renders a single-line strip suited for
 * tight surfaces like the checkout summary. The default variant renders a
 * full panel with title + body — fits product/help pages.
 */
export default function PolicyCard({ variant = "default", className = "" }) {
  const { t } = useLanguage();
  const S = t.store;

  if (variant === "compact") {
    return (
      <div
        data-testid="policy-card-compact"
        className={`flex items-start gap-2.5 rounded-xl border border-[#F37021]/25 bg-[#FFF8F1] px-3 py-2.5 ${className}`}
      >
        <RefreshCw className="w-4 h-4 text-[#F37021] mt-0.5 flex-shrink-0" />
        <p className="text-[12px] leading-snug text-[#3a2a1a]">{S.policyShort}</p>
      </div>
    );
  }

  return (
    <section
      data-testid="policy-card"
      className={`rounded-2xl border border-black/5 bg-white p-5 sm:p-6 ${className}`}
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-[#FDF1E8] flex items-center justify-center flex-shrink-0">
          <RefreshCw className="w-4.5 h-4.5 text-[#F37021]" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-[15px] sm:text-base text-[#111]">
            {S.policyTitle}
          </h3>
          <p className="mt-1.5 text-[13px] sm:text-sm text-[#555] leading-relaxed">
            {S.policyBody}
          </p>
        </div>
      </div>
    </section>
  );
}
